import Vue from 'vue'
import Vuex from 'vuex'

/* eslint-disable */
import jwtDecode from 'jwt-decode'
import router from '@/router'

Vue.use(Vuex)

// Add 6 sept 2023 - AJUSTES CRM
const nNotifyFromLocalStorage = parseInt(localStorage.getItem('nNotifySeller')) || 0; // GERENTE y VENDEDOR
export default new Vuex.Store({
  state: {
    // token: '', ORIGINAL 
    token: localStorage.getItem('token') || '',
    userDb: '',
    /* nameUser */
    userLogin:{},
    isLoading:true,
    /**
     * ? add 6 sept 2023 - AJUSTES CRM
    */
    nNotify: nNotifyFromLocalStorage,
  },
  mutations: {
    getUser(state,payload){
      state.token = payload;
      if (payload === '') {
        state.userDb = ''
      }else{
        state.userDb = jwtDecode(payload)
      }
    },
    /**
     * ? add 6 sept 2023
    */
    updateNotifySeller(state,count){
      state.nNotify = count;
    },
  },
  actions: {
    saveUser({commit}, payload){
      /* ENCRIPTAR EL TOKEN AL ALMACENARLO EN LOCALSTORAGE sabado 27 mayo 2023 2:22pm */
      /* ENCRIPTAR EL TOKEN AL ALMACENARLO EN LOCALSTORAGE sabado 27 mayo 2023 2:22pm */
      /* save data localstorage */
      localStorage.setItem('token',payload);
      commit('getUser',payload);
    },
    logOut({commit}){
      commit('getUser','');
      localStorage.removeItem('token');
      /* REMOVE idCustomer, nameCustomer 1 julio 2023 */
      localStorage.removeItem('nameCustomer')
      localStorage.removeItem('lastCustomer')
      /** add 19 julio 2023 ** */
      localStorage.removeItem('lastContactCreated')
      localStorage.removeItem('lastContactCreatedId')
      /** Add 6 sept 2023 - Limpiar del localStorage el numero notificacioens vendedor */
      localStorage.removeItem('nNotify')
      /**
       * ! REVISAR ESTA PROPIEDAD 6 SEPT 2023 AJUSTES CRM
       */
      localStorage.removeItem('nNotifySeller')
      router.push({name: 'login'})
    },
    readToken({commit}){
      const token = localStorage.getItem('token');
      if (token) {
        commit('getUser',token)
      }else{
        commit('getUser','');
      }
    },
  },
  getters:{
    isActive : state => !!state.token,
    getInfoUser(state){
      state.userLogin = {
        name: state.userDb.name,
        email: state.userDb.email,
        /* NECESITO EL ID PARA FILTRAR LOS CLIENTES CREADOS POR UN USUARIO */
        _id: state.userDb.id 
      }
      return state.userLogin;
    }
  },
  modules: {
  }
})
